<template>
  <div class="callBack">
    <van-popup v-model="feedbackShow" position="bottom">
      <div class="feedback-popup">
        <van-nav-bar
          right-text="提交"
          :left-arrow="false"
          :border="false"
          @click-right="submitFeedback"
        >
          <template #title>
            <div v-if="dataType===1">您和招工方取得联系了吗</div>
            <div v-else>您和找活方取得联系了吗</div>
          </template>
        </van-nav-bar>

        <div class="feedback-popup-content">
          <div class="feedback-popup-title" v-if="dataType===1">请您反馈与招工方的联系情况，以便我们更好的帮您找到合适的工作</div>
          <div class="feedback-popup-title" v-else>请您反馈与找活方的联系情况，以便我们更好的帮您找到合适的工人</div>

          <van-row gutter="20">
            <van-col span="12" v-if="data.contactFlag===1">
              <img src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/btn_success_selected.png">
            </van-col>
            <van-col span="12" v-else @click="data.contactFlag=1">
              <img src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/btn_sucess_default.png">
            </van-col>

            <van-col span="12" v-if="data.contactFlag===0">
              <img src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/btn_fail_selected.png">
            </van-col>

            <van-col span="12" v-else @click="data.contactFlag=0">
              <img src="https://yiyong-pub.oss-cn-shanghai.aliyuncs.com/yaogongapp/pubWorker/btn_fail_default.png">
            </van-col>

            <van-col span="12" v-for="(item, index) in labels" :key="index">
              <van-button round :class="data.content===item.value ?'selected':'default'"
                          @click="data.content=item.value">
                {{ item.label }}
              </van-button>
            </van-col>

          </van-row>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { callBack, callBackContent } from '@api/integralMall'

export default {
  name: 'callBack',
  props: ['dataType', 'dataId'],
  data () {
    return {
      feedbackShow: false,
      labels: [],
      data: {
        contactFlag: '',
        content: ''
      }
    }
  },
  created () {
  },
  mounted () {
    this.token = localStorage.getItem('token')
    if (this.token && this.token !== 'undefined') {
      this.callBackContent()
    }
  },
  methods: {
    // 显示电话反馈
    showFeedback () {
      this.data = {
        contactFlag: '',
        content: ''
      }
      this.feedbackShow = true
    },

    // 获取用户加密手机号（用于分享）
    callBackContent () {
      callBackContent({ dataType: this.dataType }).then(res => {
        if (res.data.code === 200) {
          this.labels = res.data.data
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },

    // 获取用户加密手机号（用于分享）
    submitFeedback () {
      if (this.data.contactFlag === '' && this.data.content === '') {
        this.$toastMsg('提交成功')
        this.feedbackShow = false
        return
      }
      if (!this.dataId || this.dataId === '') {
        this.$toastMsg('提交成功')
        this.feedbackShow = false
        return
      }
      this.data.dataType = this.dataType
      this.data.dataId = this.dataId
      callBack(this.data).then(res => {
        if (res.data.code === 200) {
          this.$toastMsg('提交成功')
          this.feedbackShow = false
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
@import "../assets/css/mixin";

.callBack {

  //noinspection CssInvalidPseudoSelector
  ::v-deep.van-nav-bar__text{
    color: black;
  }

  .feedback-popup {
    font-size: 14px;
    text-align: center;

    .feedback-popup-content {
      padding: 0 16px 20px;

      .selected {
        background-color: #FFF1D2FF;
        border: 1px solid #FFF1D2FF;

        .van-button__text {
          color: #FE9930FF;
        }
      }

      .default {
        background-color: #EEEEEEFF;
      }
    }

    .feedback-popup-title {
      padding: 6px 16px;
    }

    .van-col {
      margin: 6px auto;

      img {
        display: inline;
        height: 44px;
        width: 132px;
      }
    }

    .van-button {
      height: 28px;
      width: 100%;

      .van-button__text {
        color: #333333FF;
      }
    }
  }
}
</style>
